var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.812 19.336v-7.762l5.692-5.693C21.564 4.82 20.813 3 19.311 3H4.689C3.191 3 2.434 4.819 3.496 5.88l5.691 5.694v6.051c0 .531.25 1.031.675 1.406l2.25 1.655c1.1.768 2.7.054 2.7-1.35m-1.687-.024-2.25-1.687v-6.75L4.687 4.687h14.625l-6.187 6.188z"
  })));
};
export default SvgFilter;